/* Cherry blossom petals drifting down behind a quote while it is on screen */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const init = (box) => {
    if (box._drPetals) return;
    box._drPetals = true;
    const layer = document.createElement('div');
    layer.className = 'dr-petals';
    layer.setAttribute('aria-hidden', 'true');
    const count = window.innerWidth < 768 ? 12 : 24;
    for (let i = 0; i < count; i++) {
      const p = document.createElement('span');
      p.className = 'dr-petal';
      p.style.setProperty('--x', (Math.random() * 100).toFixed(1) + '%');
      p.style.setProperty('--s', (13 + Math.random() * 11).toFixed(1) + 'px');
      p.style.setProperty('--d', (9 + Math.random() * 7).toFixed(1) + 's');
      p.style.setProperty('--dl', (-Math.random() * 14).toFixed(1) + 's');
      p.style.setProperty('--sw', ((Math.random() - .3) * 90).toFixed(0) + 'px');
      layer.appendChild(p);
    }
    box.style.setProperty('--h', box.offsetHeight + 'px');
    box.appendChild(layer);
    new ResizeObserver(() => box.style.setProperty('--h', box.offsetHeight + 'px')).observe(box);
    new IntersectionObserver((e) => box.classList.toggle('dr-petals-on', e[0].isIntersecting)).observe(box);
  };
  const run = () => document.querySelectorAll('[data-dr-petals]').forEach(init);
  run();
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();
